import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const HeadlineTextViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    font-size: 24px;
    margin-bottom: 20px;
  `,
  tablet: css``,
  tabletLandscape: css`
    margin-top: auto;
  `,

  browser: css``,
};

export const HeadlineText = styled.h1`
  margin-bottom: 40px;

  color: ${({ theme }) => theme.colors.nrmaBlue};

  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return HeadlineTextViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? HeadlineTextViews["tabletLandscape"]
          : HeadlineTextViews["tablet"];

      case "browser":
        return HeadlineTextViews["browser"];
    }
  }}
`;
